<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Scrollbar</strong></h4>
      <a href="https://mdbootstrap.com/vue/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-4" />
    <container class="mt-5 d-flex justify-content-center">
      <Scrollbar class="img-wrapper" :wheelSpeed="0.3">
        <div class="img">
        </div>
      </Scrollbar>
    </container>
  </container>
</template>

<script>
import { Container, Scrollbar, Row, Fa } from 'mdbvue';

export default {
  name: 'ScrollbarPage',
  components: {
    Container,
    Scrollbar,
    Row,
    Fa
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-wrapper {
  position: relative;
  width: 480px;
  height: 320px;
  margin: auto;
}

.img-wrapper .img {
  position: relative;
  background-image: url('https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(33).jpg');
  background-size: cover;
  width: 1280px;
  height: 720px;
}
</style>
